import { Box, Heading, Image, Stack, Text } from "@chakra-ui/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

export const Cleancontrol = () => {
  var settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2200,
    pauseOnHover: true,
  };
  return (
    <Box textAlign={"center"} mt={"20px"} pt={"50px"} bgColor={"white"} pb={"50px"}>
      <Heading as={"small"} fontWeight={"Bold"} pb={"30px"}>
        Cleaning & Pest Control
      </Heading>
      <Stack width={"60%"} margin={"auto"} mt={"16vh"} gap={"10px"}>
        <Slider {...settings}>
          <Box alignItems={"center"}>
            <Image
              src={
                "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/home-screen/1625159882387-9585c7.jpeg"
              }
              borderRadius={"5px"}
              h={"15vh"}
              width={"90%"}
            />
            <Text opacity={"0.7"}>Bathroom & Kitechen Cleaning</Text>
          </Box>
          <Box alignItems={"center"}>
            <Image
              src={
                "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/luminosity/1632396793425-1a5418.jpeg"
              }
              h={"15vh"}
              borderRadius={"5px"}
              width={"90%"}
            />
            <Text>Full Home Cleaning</Text>
          </Box>
          <Box alignItems={"center"}>
            <Image
              src={
                "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/home-screen/1630420912606-2fffa6.jpeg"
              }
              h={"15vh"}
              borderRadius={"5px"}
              width={"90%"}
            />
            <Text>Sofa and Carpet Cleaning</Text>
            <Text as={"small"} fontWeight={"light"}>
              Free Head Massage
            </Text>
          </Box>
          <Box alignItems={"center"}>
            <Image
              src={
                "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/luminosity/1631159612066-53b210.jpeg"
              }
              h={"15vh"}
              borderRadius={"5px"}
              width={"90%"}
            />
            <Text>Cockcratch,Ant & General Pest Control</Text>
          </Box>
          <Box alignItems={"center"}>
            <Image
              src={
                "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/luminosity/1632490257439-ef28d2.jpeg"
              }
              h={"15vh"}
              borderRadius={"5px"}
              width={"90%"}
            />
            <Text>Bed Bugs Control</Text>
          </Box>
        </Slider>
      </Stack>
    </Box>
  );
};
